import { cn } from '@helpers/cn';

import { TProps } from './types/TProps';

export const Skeleton = ({ className }: TProps) => (
  <span aria-hidden="true" className={cn('skeleton motion-safe:animate-pulse', className)} />
);
